import { css } from "@emotion/css";
import { minScreen } from "utils/mediaQueries";
import { Color } from "utils/variables";
import { buttonInteraction } from "utils/mixin";

export const body = css`
  width: 160px;
  height: 140px;
  background: #000;
  border-radius: 0 10px 0 0;
  position: relative;
  ${minScreen("md")} {
    width: 210px;
  }
`;
export const bodyExpand = css`
  width: 100%;
  height: 100%;
  border-radius: 0;
  video {
    border-radius: 0;
  }
`;
export const bodyExtendFront = css`
  width: 220px;
  height: 150px;
  position: absolute;
  bottom: 86px;
  right: 10px;
  border: 3px solid ${Color.White};
  border-radius: 14px;
  box-sizing: border-box;
  transition: border-color 0.5s;
  z-index: 3;
  video {
    border-radius: 10px;
  }
  ${minScreen("md")} {
    width: 300px;
    height: 204px;
  }
`;

export const switchIconWrap = css`
  position: absolute;
  top: 12px;
  right: 18px;
  cursor: pointer;
  line-height: 1;
  ${minScreen("md")} {
    display: none;
  }
`;
export const switchIcon = css(
  buttonInteraction,
  css`
    fill: ${Color.White};
  `
);

export const settings = css`
  width: 100%;
  padding: 0 10px;
  position: absolute;
  bottom: 9px;
  left: -2px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const myname = css`
  margin: 0;
  position: absolute;
  top: 15px;
  left: 10px;
  color: ${Color.White};
  font-size: 9px;
  line-height: 9px;
`;

export const video = css`
  width: 100%;
  height: 100%;
  border-radius: 0 10px 0 0;
  object-fit: cover;
`;

export const cameraoff = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: linear-gradient(
    139.19deg,
    rgba(243, 105, 105, 0.9) 16%,
    rgba(248, 169, 2, 0.9) 104.66%
  );
  border-radius: 0 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const cameraoffExpand = css`
  border-radius: 0;
`;
export const cameraoffExtendFront = css`
  border-radius: 10px;
`;

export const avatorWrap = css`
  width: 68px;
  height: 68px;
  border: 4px solid ${Color.White};
  border-radius: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.5s;
`;
export const avatorWrapExpand = css`
  width: 102px;
  height: 102px;
`;
export const avatorWrapNoBorder = css`
  border: none;
`;
export const avator = css`
  fill: ${Color.White};
`;
export const avatorName = css`
  margin: 0;
  color: ${Color.White};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`;
